import Vue from "vue";

const getDefaultState = () => {
	return {
		// snackbar
		showSnackbar: false,
		snackbarMessage: "",
		snackbarColor: "",
		snackbarDuration: 3000,
		// dialog
		dialogShow: false,
		dialogPersistent: false,
		dialogType: "",
		dialogTitle: "",
		dialogMessage: "",
		dialogSelectItems: [],
		dialogCheckName: "",
		dialogCheckValue: false,
		dialogCheckEnabled: false,
		dialogSelectID: null,
		dialogMailText: "",
		dialogConfirmText: "",
		dialogOkCb: () => {},
		dialogCancelCb: () => {},
		//alert
		showAlert: false,
		alertMessage: "",
		alertDuration: -1,
		_changes_not_saved: false,
	};
};
// initial state
const state = getDefaultState();

const getters = {
	// snackbar
	showSnackbar: (state) => {
		return state.showSnackbar;
	},
	snackbarMessage: (state) => {
		return state.snackbarMessage;
	},
	snackbarColor: (state) => {
		return state.snackbarColor;
	},
	snackbarDuration: (state) => {
		return state.snackbarDuration;
	},
	// dialog
	showDialog: (state) => {
		return state.dialogShow;
	},
	dialogType: (state) => {
		return state.dialogType;
	},
	dialogTitle: (state) => {
		return state.dialogTitle;
	},
	dialogMessage: (state) => {
		return state.dialogMessage;
	},
	dialogConfirmText: (state) => {
		return state.dialogConfirmText;
	},
	dialogMailText: (state) => {
		return state.dialogMailText;
	},
	dialogSelectItems: (state) => {
		return state.dialogSelectItems;
	},
	dialogCheckValue: (state) => {
		return state.dialogCheckValue;
	},
	dialogCheckEnabled: (state) => {
		return state.dialogCheckEnabled;
	},
	dialogCheckName: (state) => {
		return state.dialogCheckName;
	},
	dialogSelectID: (state) => state.dialogSelectID,
	// alert
	showAlert: (state) => {
		return state.showAlert;
	},
	alertMessage: (state) => {
		return state.alertMessage;
	},
	alertDuration: (state) => {
		return state.alertDuration;
	},
	changes_not_saved: (state) => state._changes_not_saved,
};

const mutations = {
	resetState_messages(state) {
		Object.assign(state, getDefaultState());
	},
	// snackbar
	showSnackbar(state, data) {
		state.snackbarDuration = data.duration || 3000;
		state.snackbarMessage = data.message || "No message.";
		state.snackbarColor = data.color || "info";
		state.showSnackbar = true;
	},
	hideSnackbar(state) {
		state.showSnackbar = false;
	},
	// dialog
	showDialog(state, data) {
		state.dialogType = data.type || "confirm";
		state.dialogTitle = data.title;
		if (data.current != undefined) {
			Vue.set(state, "dialogSelectID", data.current);
		} else {
			state.dialogSelectID = null;
		}
		if (data.CheckValue != undefined) {
			state.dialogCheckValue = data.CheckValue;
		} else {
			state.dialogCheckValue = false;
		}
		if (data.CheckEnabled != undefined) {
			state.dialogCheckEnabled = data.CheckEnabled;
		} else {
			state.dialogCheckEnabled = false;
		}
		(state.dialogCheckName = data.CheckName), (state.dialogMessage = data.message);
		state.dialogSelectItems = data.SelectItems;
		state.dialogMailText = data.dialogMailText;
		state.dialogConfirmText = data.dialogConfirmText;
		state.dialogOkCb = data.okCb || function () {};
		state.dialogMailCb = data.mailCb || function () {};
		state.dialogselectCb = data.selectCb || function () {};
		state.dialogCancelCb = data.cancelCb || function () {};
		if (data.dialogPersistent) {
			state.dialogPersistent = true;
		} else {
			state.dialogPersistent = false;
		}
		state.dialogShow = true;
	},
	hideDialog(state) {
		state.dialogShow = false;
	},
	dialogOk(state) {
		if (!state.dialogPersistent) {
			state.dialogShow = false;
		}
		state.dialogOkCb();
	},
	dialogSelect(state, id) {
		state.dialogSelectID = id;
		if (!state.dialogPersistent) {
			state.dialogShow = false;
		}
		state.dialogselectCb();
	},
	dialogConfirm(state, text) {
		state.dialogConfirmText = text;
		if (!state.dialogPersistent) {
			state.dialogShow = false;
		}
		state.dialogOkCb();
	},
	dialogMail(state, text) {
		state.dialogMailText = text;
		if (!state.dialogPersistent) {
			state.dialogShow = false;
		}
		state.dialogMailCb();
	},
	dialogCancel(state) {
		state.dialogCancelCb();
		state.dialogShow = false;
	},
	// alert
	showAlert(state, data) {
		state.alertMessage = data.message || "No message.";
		state.alertDuration = data.duration || 0;
		state.showAlert = true;
	},
	hideAlert(state) {
		state.showAlert = false;
	},
	setDialogMailText(state, value) {
		state.dialogMailText = value;
	},
	setDialogConfirmText(state, value) {
		state.dialogConfirmText = value;
	},
	setDialogCheckValue(state, value) {
		state.dialogCheckValue = value;
	},
	setChanges_not_saved(state, val) {
		Vue.set(state, "_changes_not_saved", val);
	},
};

export default {
	state,
	getters,
	mutations,
};
